<form #form novalidate (ngSubmit)="onSubmit()">
    <div id="routeDetailsContainer" class="container absolute top-20 right-0 z-30 hiddenDetails" [ngClass]="{ 'openDetails': (route() || newRoute()) && !closed(), 'expanded': expanded, 'w-8!': closed() }">
        @if (!closed()) {
            <section class="bg-primary-purple-light-2 h-14 mt-4 flex items-center">
                @if (route() && route().id) {
                    <h1 class="ml-8 text-xl font-semibold max-w-[25%] truncate">{{ literalService.get('services.routes.routeTitle', true) }}</h1>
                    <div class="flex items-center justify-center ml-2 mr-2 z-10" [ngClass]="{'cursor-pointer content-image': expanded}" (click)="expanded && editStatusClick()">
                        <img [src]="images.services.route" [alt]="route().active ? 'route-activated' : 'route-deactivated'" class="h-6 w-6" />
                    </div>
                    @if (editStatus) {
                        <app-select [styles]="'mt-1'" [elements]="routeStatusList" [value]="route().active ? 'activated' : 'deactivated'" [id]="route().active ? 'activated' : 'deactivated'" [translateValue]="true" [haveImage]="true" (change)="changeStatus($event.target)" (onBlur)="changeStatus(null)" />
                    }
                    <section id="actions" class="flex ml-auto mr-8">
                        <div class="flex items-center justify-center content-image mr-2" (click)="openFareModal()">
                            <img [src]="images.services.routes.fare" [tooltip]="literalService.get('services.routes.tooltips.fare', true)" alt="fare" class="h-6 w-6 mr-4 ml-4 cursor-pointer">
                        </div>
                        @if (expanded) {
                            <div class="flex items-center justify-center content-image mr-2" (click)="duplicateEventEmitter.emit(route())">
                                <img [src]="images.services.duplicate" [tooltip]="literalService.get('services.routes.tooltips.duplicate', true)" alt="duplicate" class="h-6 w-6 mr-4 ml-4 cursor-pointer">
                            </div>
                            @if (showItineraries()) {
                                <a [routerLink]="['/services', route().serviceId, 'routes', route().id, 'itineraries']" class="flex items-center justify-center content-image mr-2 rounded focus-visible:outline-2 focus-visible:outline-primary-purple" [attr.aria-label]="literalService.get('services.routes.tooltips.itineraries', true)" [tooltip]="literalService.get('services.routes.tooltips.itineraries', true)">
                                    <img [src]="images.itineraries.itineraries" alt="" aria-hidden="true" class="h-6 w-6 mr-4 ml-4">
                                </a>
                            }
                        }
                        <div class="flex items-center justify-center content-image mr-2" (click)="editEvent.emit()">
                            <img [src]="images.services.edit" [tooltip]="literalService.get('services.routes.tooltips.edit', true)" alt="edit" class="h-6 w-6 mr-4 ml-4 cursor-pointer">
                        </div>
                        @if (expanded && userRole === 'SUPERADMIN') {
                            <div class="flex items-center justify-center content-image mr-2" (click)="deleteEventEmitter.emit(route().id)">
                                <img [src]="images.services.delete" [tooltip]="literalService.get('services.routes.tooltips.delete', true)" alt="delete" class="h-6 w-6 mr-4 ml-4 cursor-pointer">
                            </div>
                        }
                        <div class="flex items-center justify-center cursor-pointer mr-2" (click)="close()">
                            <img [src]="images.close" alt="closeDetails" class="h-6 w-6"/>
                        </div>
                    </section>
                } @else {
                    <h1 class="ml-8 text-xl font-semibold max-w-[50%] truncate">{{ literalService.get('services.routes.newRoute', true) }}</h1>
                    <section id="actions" class="flex ml-auto mr-8">
                        <div class="flex items-center justify-center content-image mr-2" (click)="openFareModal()">
                            <img [src]="images.services.routes.fare" [tooltip]="literalService.get('services.routes.tooltips.fare', true)" alt="fare" class="h-6 w-6 mr-4 ml-4 cursor-pointer">
                        </div>
                        <div class="flex items-center justify-center cursor-pointer mr-2" (click)="close()">
                            <img [src]="images.close" alt="closeDetails" class="h-6 w-6"/>
                        </div>
                    </section>
                }
            </section>  
        }
        <section class="mt-8 ml-8 pb-24 justify-between items-center overflow-auto" [ngClass]="closed() ? 'h-[calc(100vh-112px)]' : 'h-[calc(100vh-182px)]'">
            <div class="flex">
                @if (!closed()) {
                    <div class="grid grid-flow-col gap-0" [ngClass]="{'containerDetails': route(), 'grid-rows-[repeat(6,auto)] gap-x-0.75 gap-y-5': edit() || newRoute(), 'grid-rows-6 gap-10': !edit() && !newRoute()}">
                        <ng-container>
                        @if (!edit() && !newRoute()) {
                            @for (element of routeForm; track $index) {
                                <article class="-mb-3.5 w-72" [ngClass]="{'hidden': element.hidden}">
                                    @if (expanded ? true : !element.expanded) {
                                        <app-detail [data]="element" [value]="element.value" />
                                    }
                                </article>
                            }
                        } @else if (edit() || newRoute()) {
                            @for (element of routeForm; track $index) {
                                <article class="mr-8" [ngClass]="{'hidden': element.hidden}">
                                    @if (expanded && element.edit ? true : !element?.expanded) {
                                        <app-input  [data]="element"
                                                    [edit]="true"
                                                    [independent]="false"
                                                    [translateValue]="element.edit?.translateValue"
                                                    (setEventEmitter)="changeData($event, element)"
                                                    (changeEventEmitter)="changeData($event, element)"
                                                    (inputEventEmitter)="liveChangeData($event, element)"
                                                    (scrollEventEmitter)="scrollFares($event)"
                                                    (searchEventEmitter)="searchFares($event)" />
        
                                    }
                                </article>
                            }
                        }
                        </ng-container>
                    </div>
                }
                <section class="flex items-center absolute right-2 top-0 bottom-0">
                    <img alt="arrowToExpand" [src]="images.arrowLeft" class="h-5 w-5 cursor-pointer expand" [ngClass]="{'actionRotateArrowOpen': !expanded, 'actionRotateArrowClose': expanded}" (click)="onExpand()" />
                </section>
            </div>
        </section>
        @if (!closed()) {
            @if (serviceWizardService.active && routeForm && routeForm.length > 0) {
                <div class="flex absolute bottom-8 right-11">
                    <app-wizard-step-buttons />
                </div>
            } @else if (!designEditMode() && (edit() || newRoute())) {
                <div class="flex absolute bottom-8 left-8">
                    <app-form-actions [saveDisabled]="!isFormValid()" (cancelAction)="newRoute() ? close() : editEvent.emit()" (saveAction)="onSubmit()" />
                </div>
            }
        }
    </div>
</form>

<!-- Fare Modal -->
<app-modal-fare
    [id]="'fareModal'"
    [modal]="fareModal"
    [fares]="fares"
    [selectedFare]="selectedFare"
    [routeId]="fareRouteId!"
    [clientId]="fareClientId!"
    [userRole]="userRole"
    [promotionalCodes]="promotionalCodes"
    [selectedPromotionalCode]="selectedPromotionalCode"
    [temporalPasses]="temporalPasses"
    [selectedTemporalPass]="selectedTemporalPass"
    (action)="handleFareAction($event)"
    (deleteFareEvent)="handleDeleteFare($event)"
    (loadMoreFares)="handleLoadMoreFares($event)"
    (searchFares)="handleSearchFare($event)"
    (activateFareEvent)="handleActivateFare($event)"
    (promotionalCodeAction)="handlePromotionalCodeAction($event)"
    (deletePromotionalCodeEvent)="handleDeletePromotionalCode($event)"
    (activatePromotionalCodeEvent)="handleActivatePromotionalCode($event)"
    (temporalPassAction)="handleTemporalPassAction($event)"
    (deleteTemporalPassEvent)="handleDeleteTemporalPass($event)"
    (activateTemporalPassEvent)="handleActivateTemporalPass($event)"
/>